const Items = [
  {
    title: "Linki",
    title1: "Artykuły",
    title2: "Filmy",
    title3: "Inni geniusze",
  },
  // {
  //   title8: "Ciekawe",
  //   title4: "Youtube",
  //   title5: "P",
  //   title6: "B",
  //   title7: "Sitemap",
  // },
];

export default Items;
